import React, { useState } from 'react';

import { PortfolioFeeRule } from '@ndvr/billing-api';

import { useRequiredParams } from 'utils';
import { AccountNameLink, Text, VerticalLayout } from 'widgets';

import { useDeletePortfolioFeeRule, usePortfolioFeeRuleTimeline } from './billing-queries';
import { PricingOverrideDrawer } from './drawers/PricingOverrideDrawer';
import { TimelinePanel } from './TimelinePanel';
import { PricingInfo } from './widgets/PricingInfo';
import { TimelineHeader } from './widgets/TimelineHeader';

export const PricingOverridesPanel = () => {
    const { globalAccountGUID } = useRequiredParams(['globalAccountGUID']);

    const { data: timeline, isLoading } = usePortfolioFeeRuleTimeline(globalAccountGUID);
    const { mutateAsync: deletePortfolioFeeRule } = useDeletePortfolioFeeRule(globalAccountGUID);

    const [editedRule, setEditedRule] = useState<PortfolioFeeRule>();
    const [drawerOpen, setDrawerOpen] = useState(false);

    return (
        <>
            <TimelineHeader
                title="Pricing Overrides"
                buttonLabel="+ New Pricing Override"
                onClick={() => {
                    setEditedRule(undefined);
                    setDrawerOpen(true);
                }}
            />
            <TimelinePanel
                timeline={timeline}
                timelineForOverrides
                isLoading={isLoading}
                onEdit={(rule) => {
                    setEditedRule(rule);
                    setDrawerOpen(true);
                }}
                onDelete={(rule) => deletePortfolioFeeRule(rule.portfolioFeeRuleGUID)}
                firstColumnRenderer={({ rule }) => (
                    <VerticalLayout>
                        <AccountNameLink accountGUID={rule.portfolioGUID} />
                        <Text $themeColor="subtle">Account</Text>
                    </VerticalLayout>
                )}
                secondColumnRenderer={({ rule }) => (
                    <>
                        <PricingInfo annualBps={rule.annualBps} />
                        <Text $themeColor="subtle">AUM charge override</Text>
                    </>
                )}
            />
            {drawerOpen && <PricingOverrideDrawer portfolioFeeRule={editedRule} onClose={() => setDrawerOpen(false)} />}
        </>
    );
};
